import { createSlice } from "@reduxjs/toolkit";
const initialStateValue = false;

export const employeeAccessToken = createSlice({
    name: "employeeAccessToken",
    initialState
        : {
        value: initialStateValue,
    },
    reducers: {
        setemployeeAccessTokenTokenReducer: (state, action) => {
            state.value = action.payload;
        },
        clearemployeeAccessTokenTokenReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});

export const { setemployeeAccessTokenTokenReducer, clearemployeeAccessTokenTokenReducer } = employeeAccessToken.actions;
export default employeeAccessToken.reducer;